import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M2.25 12q-.6 0-1.05-.45T.75 10.5V9q0-.131.037-.281t.076-.281l2.25-5.288q.168-.375.562-.637.394-.263.825-.263h8.25V12l-4.5 4.462a1.1 1.1 0 0 1-.666.329 1.23 1.23 0 0 1-.74-.141 1.2 1.2 0 0 1-.525-.525.95.95 0 0 1-.075-.694L7.088 12zm9-.637V3.75H4.5L2.25 9v1.5H9l-1.013 4.125zM15 2.25q.619 0 1.06.441.44.441.44 1.059v6.75q0 .619-.44 1.06A1.44 1.44 0 0 1 15 12h-2.25v-1.5H15V3.75h-2.25v-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }